import Request from "../lib/request";

export const getPosts = (params) => {
  return Request({
    url: "wp/v2/posts",
    method: "get",
    params,
  });
};
export const getPostMedia = (id) => {
  return Request({
    url: "wp/v2/media/" + id,
    method: "get"
  });
};
export const getCategories = () => {
  return Request({
    url: "wp/v2/categories",
    method: "get"
  });
};